export default __webpack_public_path__ + "static/media/gamma-logo.a0e63538.jpg";